'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var BackwardIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<polygon stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="  5,1 5,7.286 16,1 16,17 5,10.714 5,17 1,17 1,1 "/>';
    case 'medium':
      return '<polygon stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="  8,1 8,13.692 30,1 30,31 8,18.308 8,31 2,31 2,1 "/>';
    case 'large':
      return '<polygon stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="  12.562,1.5 12.562,20.538 45.562,1.5 45.562,46.5 12.562,27.462 12.562,46.5 2.438,46.5 2.438,1.5 "/>';
    }
  }
});

module.exports = BackwardIcon;



/** WEBPACK FOOTER **
 ** ./atoms/icons/Backward.jsx
 **/